import colors from '@sportninja/common/constants/appColors'
import { getGameTeamRosters } from '@sportninja/common/utils/games'
import useGameRosters from './useGameRosters'

interface PlayerType {
  id: string
  name: string
  name_full: string
  abbreviation: string
  is_goalie: number
}

interface RosterPlayer {
  id: string
  name_first: string
  name_middle: string | null
  name_last: string
  player_number: number
  play_direction: string | null
  is_affiliate: boolean
  is_injured: boolean
  is_playing: boolean
  is_starting: boolean
  is_proposed_starting: boolean
  is_suspended: boolean
  attendance_status: string | null
  customer_identifier: string
  is_signed_waiver: boolean
  league_registration_number: string | null
  player_type: PlayerType
}

interface TeamOfficial {
  id: string
  name_first: string
  name_middle: string | null
  name_last: string
  name_full: string | null
  team_official_type: number
  full_name: string | null
  birth_date: string | null
  created_at: string
  gender: string | null
  email: string | null
  phone_number: string | null
  invitation_id: string | null
  is_accepted: boolean
  is_invited: boolean
}

interface GameRoster {
  id: string
  team_id: string
  game_id: string
  jersey_color: string | null
  updated_at: string
  refreshments_player_id: string | null
  refreshments_team_official_id: string | null
  video_user_id: string | null
  players: RosterPlayer[]
  team_officials: TeamOfficial[]
  signatures: unknown[]
}

interface UseGameJerseyColorsParams {
  gameId: string | null | undefined
  game:
    | {
        homeTeamId?: string
        visitingTeamId?: string
        homeTeamActiveRoster?: { jersey_color_home?: string }
        visitingTeamActiveRoster?: { jersey_color_visiting?: string }
      }
    | null
    | undefined
}

const useGameJerseyColors = ({ gameId, game }: UseGameJerseyColorsParams) => {
  const { data: gameRostersData } = useGameRosters({ gameId })

  const { homeGameRoster, visitingGameRoster } = getGameTeamRosters(
    gameRostersData,
    game?.homeTeamId,
    game?.visitingTeamId
  ) as {
    homeGameRoster: GameRoster | null
    visitingGameRoster: GameRoster | null
  }

  const homeJerseyColor =
    homeGameRoster?.jersey_color ||
    game?.homeTeamActiveRoster?.jersey_color_home ||
    colors.PRIMARY

  const visitorJerseyColor =
    visitingGameRoster?.jersey_color ||
    game?.visitingTeamActiveRoster?.jersey_color_visiting ||
    colors.SECONDARY_300

  return { homeJerseyColor, visitorJerseyColor }
}

export default useGameJerseyColors
